import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-605f1c67"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-container xag-flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "expect-box" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "waitting-icon" }),
    /*#__PURE__*/_createElementVNode("div", null, "敬请期待")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, {
      title: "故障报修",
      isReturnLeftEvent: "",
      onLeftClick: _ctx.onLeftClick
    }, null, 8, ["onLeftClick"]),
    _hoisted_1
  ], 64))
}